import InboxRule from 'owa-service/lib/contract/InboxRule';
import mapInboxRuleToInboxRuleInformation from './utils/mapInboxRuleToInboxRuleInformation';
import InboxRuleActionSource from './store/schema/InboxRuleActionSource';

export default {
    enableDisableInboxRuleDatapoint: {
        name: 'TnS_EnableDisableInboxRule',
        customData: (
            inboxRuleId: string,
            shouldBeEnabled: boolean,
            force: boolean,
            alwaysDeleteOutlookRulesBlob: boolean
        ) => [inboxRuleId, shouldBeEnabled, force, alwaysDeleteOutlookRulesBlob],
    },
    generateInboxRulesDiagnosticReportDatapoint: { name: 'TnS_GenerateInboxRulesDiagnosticReport' },
    getInboxRulesDatapoint: { name: 'TnS_GetInboxRules' },
    setInboxRuleDatapoint: {
        name: 'TnS_SetInboxRule',
        customData: (
            inboxRule: InboxRule,
            force: boolean,
            alwaysDeleteOutlookRulesBlob: boolean
        ) => {
            const result = mapInboxRuleToInboxRuleInformation(inboxRule);
            result.Force = force;
            result.AlwaysDeleteOutlookRulesBlob = alwaysDeleteOutlookRulesBlob;
            return result;
        },
    },
    setInboxRulesDatapoint: { name: 'TnS_SetInboxRules' },
    addPhraseToClauseDatapoint: {
        name: 'TnS_AddPhraseToClause',
        customData: (
            clauseId: string,
            phraseToAdd: string,
            actionSource: InboxRuleActionSource
        ) => [phraseToAdd.indexOf(' ') !== -1, actionSource],
    },
};
